module.exports = __webpack_public_path__ + "img/ic-manage.6e2ba971.png";